import React from 'react'
import PropTypes from 'prop-types'

import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import Modal from 'component/Modal/index'
import moment from 'moment'
import { FORMAT_DATE_TRUNC } from 'constants/config'
import { getMoneyValue } from 'component/ircLists/pureFunctions'

class ViewModal extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    currentItem: PropTypes.object,
    toggleView: PropTypes.func,
    toggleEdit: PropTypes.func,
    toggleUpload: PropTypes.func,
  }

  state = {
    irc: null,
    loading: false,
    error: null,
  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData = async () => {
    const { user, currentItem } = this.props

    if (user) {
      this.setState({ loading: true })

      const query = {
        idInventoryCriteria: currentItem.idInventoryCriteria,
      }

      try {
        const { data } = await new Api(user.dsToken).get(
          API_URL.INVENTORY_CRITERIA_FETCH_ID,
          query
        )

        this.onFetchSuccess(data)
      } catch (error) {
        this.onFetchError(error)
      }
    }
  }

  onFetchSuccess = (irc) => {
    this.setState({ irc, loading: false, error: null })
  }

  onFetchError = (error) => {
    this.setState({ error, loading: false, irc: null })
  }

  render() {
    const { toggleView, translate, currentItem, toggleEdit, toggleUpload } =
      this.props
    const { irc } = this.state

    return (
      <Modal
        title={translate('irc.view.title')}
        confirmButtonText={translate('edit_button_label')}
        cancelButtonText={translate('close_button_label')}
        isOpen
        size={'md'}
        onCloseModal={() => toggleView(false)}
        onConfirm={() => {
          toggleView(false)
          if (!irc.inProductsList) {
            toggleEdit(true, currentItem)
          } else {
            toggleUpload(true, currentItem, true)
          }
        }}
      >
        <>
          {irc && (
            <>
              <div className='w-100 margin-top color-default'>
                {translate('irc.name')}
              </div>
              <div className='w-100'>{irc.dsListName}</div>
              {(irc.inAllBranchs ||
                (irc.listRegionsAndBranchs &&
                  !!irc.listRegionsAndBranchs.length)) && (
                <>
                  <div className='margin-top w-100 color-default'>
                    {translate('irc.comprehensiveness')}
                  </div>
                  <div className='w-100'>
                    {irc.inAllBranchs
                      ? translate('irc.all')
                      : irc.listRegionsAndBranchs
                          .map(
                            (regionOrBranch) => regionOrBranch.dsBranchOrRegion
                          )
                          .join(', ')}
                  </div>
                </>
              )}
              {irc.section && (
                <>
                  <div className='margin-top w-100 color-default'>
                    {translate('section')}
                  </div>
                  <div className='w-100'>{` ${irc.section.sectionId} - ${irc.section.description}`}</div>
                </>
              )}
              {irc.subSection && (
                <>
                  <div className='margin-top w-100 color-default'>
                    {translate('subSection')}
                  </div>
                  <div className='w-100'>{` ${irc.subSection.subSectionId} - ${irc.subSection.description}`}</div>
                </>
              )}
              {irc.item && (
                <>
                  <div className='margin-top w-100 color-default'>
                    {translate('type')}
                  </div>
                  <div className='w-100'>{` ${irc.item.typeId} - ${irc.item.description}`}</div>
                </>
              )}
              {irc.subItem && (
                <>
                  <div className='margin-top w-100 color-default'>
                    {translate('subType')}
                  </div>
                  <div className='w-100'>{` ${irc.subItem.subTypeId} - ${irc.subItem.description}`}</div>
                </>
              )}
              {(irc.dtBegin || irc.dtEnd) && (
                <>
                  <div className='margin-top w-100 color-default'>
                    {translate('irc.validity')}
                  </div>
                  <div className='w-100'>
                    {moment(irc.dtBegin).format(FORMAT_DATE_TRUNC)} -{' '}
                    {moment(irc.dtEnd).format(FORMAT_DATE_TRUNC)}
                  </div>
                </>
              )}
              {(!!irc.inProductsVlAbove ||
                !!irc.inProductsAvs ||
                !!irc.inProductsStockNeg ||
                !!irc.inItemsNoSale) && (
                <div className='margin-top-double padding-bottom'>
                  {!!irc.inProductsVlAbove && (
                    <div className='w-100 margin-top'>
                      {translate('irc.products-value-above')}{' '}
                      {getMoneyValue(irc.vlProductsAbove)}
                    </div>
                  )}

                  {!!irc.inProductsAvs && (
                    <div className='w-100 margin-top'>
                      {translate('irc.avs-products')}
                    </div>
                  )}

                  {!!irc.inProductsStockNeg && (
                    <div className='w-100 margin-top'>
                      {translate('irc.negative-stock-products')}
                    </div>
                  )}

                  {!!irc.inItemsNoSale && (
                    <div className='w-100 margin-top'>
                      {translate('irc.days-no-sale-items-1')} {irc.qtDaysNoSale}{' '}
                      {translate('irc.days-no-sale-items-2')}
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </>
      </Modal>
    )
  }
}

export default ViewModal
export { ViewModal }
